<template>
  <div class="basic_wrap">
    <div class="login_bg">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('register.register') }}
      </div>
      <div
        class="language"
        @click="$router.push('/language')"
      >
        <img :src="require('../images/language/'+lang+'.png')">
      </div>
    </div>
		
    <div class="cont">
      <img
        src="../images/shop/bg.png"
        class="bg-img"
      >
      <div class="bg-wrapper">
        <div
          
          class="logos"
        >
       <!--   <img
			v-if="config.logo"
            :src="config.logo"
            class="login-logo-img"
          > -->
        </div>
        <div class="inputs">
          <form class="form-signin">
            <div class="form-group">
              <div class="names">
                <span>*</span>{{ $t('register.inunanme') }}
              </div>
              <input
                v-model.trim="data.unanme"
                type="text"
                class="form-control"
                :placeholder="$t('register.inunanme')"
                @input="chageuname"
              >
              <!-- <input type="text" id="phone" name="tel" placeholder="请设置您的平台登录账号"
		                           aria-label="Recipient's username" class="form-control" style="flex: 3 1 0%;"> -->
            </div>
            <div class="form-group">
              <div class="names">
                <span>*</span>{{ $t('login.password') }}
              </div>
              <input
                v-model.trim="data.password"
                :type="password"
                class="form-control form-control-lg text-center"
                :placeholder="$t('register.password')"
              >
              <!-- <input type="password" name="pwd" placeholder="你的密码" value="" required="required"
		                           class="form-control form-control-lg text-center"> -->
            </div>
            <div class="form-group">
              <div class="names">
                <span>*</span>{{ $t('register.spassword') }}
              </div>
              <input
                v-model.trim="data.spassword"
                :type="password"
                class="form-control form-control-lg text-center"
                :placeholder="$t('register.spassword')"
              >
            </div>
            <!--  <div class="form-group">
		                    <div class="names"><span>*</span>{{$t('register.safepassword')}}</div>
							<input type="password" class="form-control form-control-lg text-center" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
						</div> -->
            <div class="form-group">
              <div class="names">
                <span>*</span>{{ $t('register.referralCode') }}
              </div>
              <input
                v-model.trim="data.t_mobile"
                type="text"
                class="form-control form-control-lg text-center"
                :placeholder="$t('register.referralCode')"
              >
            </div>
						
            <div class="row mx-0 mt-4">
              <div
                class="registerBtn"
                @click="submit"
              >
                {{ $t('register.register') }}
              </div>
            </div>
          </form>
          <div
            class="row mx-0 text-center justify-content-center"
          >
            <!-- {{$t('register.signIn')}} -->
            <router-link
              class="link auth-link"
              to="/login"
            >
              {{ $t('register.signIn') }}
            </router-link>
            <!-- <a class="mt-4 d-block" style="color: rgb(255, 255, 255);">登录</a> -->
          </div>
        </div>
      </div>
    </div>
		
		
    <!-- <div class="login_logo">
			<img class="logo" src="../images/shop2/logo.png" />
		</div> -->
    <div class="form">
      <!-- 	<div class="cut_login">
				<router-link to="/login">
					{{$t('register.signIn')}}
					<div class="line" />
				</router-link>
				<router-link class="cur" to="/register">
					{{$t('register.signUp')}}
					<div class="line" />
				</router-link>
			</div> -->
      <!-- 		<div class="item">
				<span class="icon">
					<van-icon name="envelop-o" size="25"/>
				</span>
				<input v-model.trim="data.mobile" type="text" class="inp" :placeholder="$t('register.phoneNumber')">
			</div> -->
      <!-- <div class="item">
				<span class="icon">
					<van-icon name="user-o" size="25"/>
				</span>
				<input v-model.trim="data.unanme" @input="chageuname" type="text" class="inp"
					:placeholder="$t('register.inunanme')">
			</div> -->
      <!-- 	<div class="item">
				<span class="icon">
					<van-icon name="user-o" size="25"/>
				</span>
				<van-radio-group v-model="sex" direction="horizontal">
				  <van-radio checked-color="#fc494d" name="1">{{$t('d.male')}}</van-radio>
				  <van-radio checked-color="#fc494d" name="2">{{$t('d.female')}}</van-radio>
				</van-radio-group>
			</div> -->
      <!-- <div class="item">
				<span class="icon">
					<van-icon name="phone-o" size="25"/>
				</span>
				<input v-model.trim="data.mobile" type="number" class="inp" :placeholder="$t('register.phoneNumber')">
			</div> -->
      <!-- <div class="item">
				<span class="icon">
					<img src="../images/login/p1.png" alt="">
				</span>
				<input type="text" class="inp" v-model.trim="data.name" placeholder="请输入用户名" />
			</div> -->
      <!-- 	<div class="item">
				<span class="icon">
					<van-icon name="lock" size="25"/>
				</span>
				<input v-model.trim="data.password" :type="password" class="inp" :placeholder="$t('register.password')">
				<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
			</div>
			<div class="item">
				<span class="icon">
					<van-icon name="lock" size="25"/>
				</span>
				<input v-model.trim="data.spassword" :type="password" class="inp"
					:placeholder="$t('register.spassword')">
				<div class="eye_bi" :class="password == 'text' ? 'eye' : ''" @click="showPwd" />
			</div> -->
      <!-- <div class="item">
                <input type="text" class="inp" v-model.trim="data.code" :placeholder="$t('forgetpwe.code')"/>
                <van-count-down :time="time" format='mm:ss' class="btn get_captcha" @finish="timeCall">
                    <template v-slot="timeData">
                        <span @click="sendcode">{{timeData.seconds > 0 ? (timeData.minutes+':'+timeData.seconds): $t('forgetpwe.send')}}</span>
                    </template>
                </van-count-down>
            </div> -->
      <!-- <div class="item">
				<input type="password" class="inp" v-model.trim="data.paypwd" placeholder="请输入支付密码" />
			</div>
			<div class="item">
				<input type="password" class="inp" v-model.trim="data.confirm_paypwd" placeholder="请再次输入支付密码" />
			</div> -->
      <!-- <div v-if="show_sms > 0" class="item">
				<input v-model.trim="data.code" type="text" class="inp" :placeholder="$t('register.code')">
				<van-count-down :time="time" format='mm:ss'  class="btn get_captcha" @finish="timeCall">
					<template v-slot="timeData">
						<span @click="sendcode">{{
						  timeData.seconds > 0
							? timeData.seconds
							: $t('register.sendCode')
						}}</span>
					</template>
				</van-count-down>
			</div> -->
      <!-- <template >
				<div class="item">
					<span class="icon">
						<van-icon name="friends-o" size="25"/>
					</span>
					<input v-model.trim="data.t_mobile" type="text" class="inp"
						:placeholder="$t('register.referralCode')">
				</div>
			</template> -->
      <!-- <div class="item_reset_pwd">
				
				<van-checkbox-group v-model="checked"  shape="square" >
					<van-checkbox name="a" checked-color="#fc494d" style="height: 35px;">
						{{$t('d.least18')}}
					</van-checkbox>
					<van-checkbox name="b" checked-color="#fc494d" style="height: 35px;">
						{{$t('d.acceptc')}}
						<a href="/#/about/35" class="" style="margin-left: 4px;">
							{{$t('d.terms')}}
						</a>
					</van-checkbox>
				</van-checkbox-group>
			</div> -->
			
      <!-- 	<div class="basic_btn sbtn" :class="
			  data.unanme == '' ||
				data.password == '' ||
					  data.spassword !=  data.password
				? 'no_touch'
				: ''
			" @click="submit">
						{{$t('register.register')}}
			</div>
			<div class="register">
				 {{$t('register.signIn')}}<router-link class="link" to="/login">{{$t('register.signUp')}}</router-link>
			</div> -->
    </div>
		
    <van-dialog
      v-model="statement"
      confirm-button-color="#ff5d7a"
      :close-on-click-overlay="true"
      @click="privacyStatementHide"
    />
    <van-dialog
      v-model="agreement"
      confirm-button-color="#ff5d7a"
      :close-on-click-overlay="true"
      @click="agreementHider"
    />
    <!-- 	<div v-if="msg_show" class="kefu" :class="show_kefu ? '' : 'kefu_hide'" @click="kefu_to">
			<img class="kefu_img" src="../images/shop2/kefu.jpg">
		</div> -->
  </div>
</template>

<script>
	import Vue from "vue";
	import {
		Icon,
		CountDown,
		RadioGroup, 
		Radio,
		Checkbox, 
		CheckboxGroup,
		Dialog
	} from "vant";
	import Fetch from "../../utils/fetch";

	Vue.use(CountDown)
		.use(Icon)
		.use(RadioGroup)
		.use(Radio)
		.use(Checkbox)
		.use(CheckboxGroup)
		.use(Dialog);

	export default {
		name: "Register",
		data() {
			return {
				time: 0,
				agreement: false,
				lang:this.$i18n.locale||"en_us",
				statement: false,
				show_kefu: false,
				msg_show: true,
				sex:"1",
				show_sms: 0,
				// checked:['a', 'b'],
				checked:[],
				password: "password",
				data: {
					password: "",
					spassword: "",
					paypwd: "",
					mobile: "",
					t_mobile: "",
					telacc: "",
					unanme: "",
					code: "",
					agent: 10000
				},
				config: {}
			};
		},
		created() {
			this.$parent.footer("user", false);
			this.getparams();
			// 安卓返回IMEI，苹果返回UID值
			/*BSL.PhoneID('callName');
			window.callName = this.methodName;
			// 获取手机OAID
			BSL.GetOAID('getExternalInfo');
			window.getExternalInfo = this.getExternalInfoData; */
		},
		mounted() {
			if (this.$route.query.agent) {
				localStorage.setItem('agent', this.$route.query.agent);
				this.data.agent = this.$route.query.agent;
			} else {
				if (localStorage.getItem('agent')) {
					this.data.agent = localStorage.getItem('agent');
				}
			}
			var that = this;
			document.body.addEventListener(
				"scroll",
				function() {
					if (!that.show_kefu) {
						return;
					}
					that.show_kefu = false;
				},
				false
			);
			document.addEventListener(
				"click",
				function(ev) {
					if (ev.target.className != "kefu_img") {
						that.show_kefu = false;
					}
				},
				false
			);
			Fetch('/index/webconfig', {
				type: 'web'
			}).then(res => {
				this.config = res.data
				this.show_sms = res.data.sms_verify
			})
		},
		methods: {
			chageuname(){
				var input = this.data.unanme;
				var stringWithoutLeadingDigit = input.replace(/^\d+/, '');
				  // 去掉字符串中的空格
				this.data.unanme = stringWithoutLeadingDigit.replace(/\s+/g, '');
			},
			kefu_to() {
				if (this.show_kefu) {
					this.$router.push("/kefu2");
				}
				this.show_kefu = !this.show_kefu;
			},
			showPwd() {
				if (this.password == "password") {
					this.password = "text";
				} else {
					this.password = "password";
				}
			},
			methodName(r) {
				this.data.imei = r;
			},
			getExternalInfoData(info) {
				var info = JSON.parse(info);
				console.log(info);
				if (info.code == 0) {
					this.data.oaid = info.oaid;
				}
			},
			getparams() {
				var m = this.$route.query.m;
				if(m && parseInt(m)>0){
					localStorage.setItem('t_mobile', m);
					this.data.t_mobile = m;
				}else{
					if (localStorage.getItem('t_mobile')) {
						this.data.t_mobile = localStorage.getItem('t_mobile');
					}
					if (localStorage.getItem('agent')) {
						this.data.t_mobile = localStorage.getItem('agent');
					}
				}
			},
			timeCall() {
				this.is_send = false;
				this.time = 0;
			},
			sendcode() {
				if (this.is_send) {
					return;
				}

				if (!this.data.mobile) {
					this.$toast(this.$t('register.phoneEmpty'));
					return;
				}

				this.is_send = true;

				Fetch("/index/register_code", {
						mobile: this.data.mobile,
					})
					.then(() => {
						this.time = 120 * 1000;
						this.$toast({
							background: "#07c160",
							message: this.$t('register.sendSuccess'),
						});
					})
					.catch(() => {
						this.is_send = false;
					});
			},
			submit() {
				if (!this.data.unanme) {
					this.$toast(this.$t('register.inunanme'));
					return false;
				}
				
				if (!this.data.password) {
					this.$toast(this.$t('register.passwordEmpty'));
					return false;
				}
				if (!this.data.spassword) {
				    this.$toast(this.$t('register.passwordError'));
				    return false;
				}
				if (this.data.password != this.data.spassword) {
				    this.$toast(this.$t('register.passwordError'));
				    return false;
				}
				// if (!this.data.paypwd) {
				// 	this.$toast(this.$t('cash.withdrawalPasswordEmpty'));
				// 	return false;
				// }
				// if (!this.data.t_mobile || this.data.t_mobile.length<3) {
				// 	this.$toast(this.$t('d.codeno'));
				// 	return false;
				// }
				

				if (!this.data.code && this.config.sms_verify) {
					this.$toast(this.$t('register.codeEmpty'));
					return false;
				}
				
				this.data.mobile = this.data.unanme;
				// if(this.checked.length!=2){
				// 	this.$toast("Please read and agree to the terms of service");
				// 	return false;
				// }
				Fetch("/index/register", {
					password: this.data.password,
					spassword: this.data.spassword,
					paypwd: this.data.paypwd,
					mobile: this.data.mobile,
					t_mobile: this.data.t_mobile,
					telacc: this.data.telacc,
					unanme: this.data.unanme,
					code: this.data.code,
					agent: this.data.agent
				}).then((res) => {
					if (res.data.token) {
						localStorage.setItem('token', res.data.token);
					}
					this.$toast(this.$t('register.signUpSuccess'));
					this.$router.replace("/");
				});
			},
			userAgreement() {
				this.agreement = true;
			},
			agreementHider() {
				this.agreement = false;
			},
			privacyStatement() {
				this.statement = true;
			},
			privacyStatementHide() {
				this.statement = false;
			},
			changeLang(lang,event) {
				Toast.loading({
					// mask: true,
					duration: 200
				})
				this.lang = lang;
				this.$i18n.locale = lang;
				localStorage.setItem("lang", lang);
				this.$router.go(-1);
			}
		},
	};
</script>

<style lang="less" scoped>
	.login_bg {
		width: 100%;
		height: 48px;
		background: none;
		background-size: 100% 100%;
		overflow: hidden;
		position: relative;
		z-index: 100;
		.language{
			position: absolute;
			top: 4px;
			right: 0;
			height: 36px;
			img{
				height: 100%;
			}
		}
	}

	.basic_wrap .form {
		margin: 5px auto 0 auto;
		width: 95%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 4px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 13px;
		padding: 31px 24px 31px 24px;
	}

	.cut_login {
		width: 207px;
		line-height: 25px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		text-align: center;
		margin: 0 auto;

		a {
			width: 50%;
			padding-bottom: 10px;
			color: #808080;
			position: relative;

			.line {
				width: 100%;
				height: 1px;
				position: absolute;
				left: 0;
				bottom: 0;
				background-color: #f2f2f2;
			}
		}

		a.cur {
			color: #ff5d7a;

			.line {
				height: 2px;
				background-image: linear-gradient(to right, #ff7791, #ff7791);
			}
		}
	}
	.big_tit{
		color: #000;
	}
	.block {
		width: 100%;
		height: 100%;
		// overflow:hidden;
		// margin: 10% auto;
		font-size: 15px;
		justify-content: center;
		background-color: #fff;
		border-radius: 5px;

		.block-title {
			display: block;
			font-weight: bolder;
			line-height: 39px;
			height: 39px;
			text-align: center;
		}

		.p_agr {
			// padding-top:30rpx;
			font-size: 12px;
			/*font-weight: bolder;*/
			line-height: 20px;
			padding: 0px 10px;
			height: 388px;
			/*overflow: hidden;*/
			// overflow: auto;
			-webkit-overflow-scrolling: touch;
			overflow-y: scroll;
		}

		.div_qd {
			width: 60px;
			height: 25px;

			span {
				width: 60px;
				height: 20px;
				line-height: 20px;
				text-align: center;
				justify-content: center;
				background: #ff5d7a;
				border-radius: 10px;
				padding: 1px 5px;
				color: #fff;
			}

			margin: 10px auto;
		}
	}

	.item {
		height: 58px;
		border-bottom: 1px solid #f0f1f3;
		font-size: 14px;
		display: flex;
		justify-content: flex-start;
		align-items: flex-end;
		padding-bottom: 4px;

		.icon {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 28px;
			height: 24px;

			.people {
				width: 23px;
				height: 20px;
			}

			img {
				height: 100%;
			}
		}

		input {
			height: 20px;
			margin-left: 7px;
			flex: 1;
			margin-bottom: 3px;
		}
	}

	.get_captcha {
		width: 88px;
		height: 34px;
		background: linear-gradient(90deg,
				#ff7791 0%,
				#ff5574 100%);
		border-radius: 4px;
		text-align: center;
		line-height: 34px;
		font-size: 14px;
		color: #ffffff;
	}

	.protocol {
		font-size: 12px;
		line-height: 17px;
		margin-top: 20px;
		color: #999999;

		a {
			color: #ff5d7a;
		}
	}

	.basic_btn {
		margin: 36px auto 0 auto;
	}
	/deep/ .van-icon {
	}
	.login_logo {
	    width: 100%;
	    color: #fff;
	    text-align: center;
	    -webkit-animation: bot_top-data .3s;
	    animation: bot_top-data .3s;
		font-size: 16px;
		color: #333;
		font-weight: bold;
	}
	.login_logo img {
	    width: 25%;
		-webkit-animation: logobig-data 1.2s;
		animation: logobig-data 1.2s;
		margin: 20px;
	}
	.form{
		-webkit-animation: bot_top-data .3s;
		animation: bot_top-data .3s;
	}
	@-webkit-keyframes bot_top-data {
	    0% {
	        margin-top: 1000px;
	        opacity: 0;
	    }
	    100% {
	        margin-top: 0;
	        opacity: 1;
	    }
	}
	
	@keyframes bot_top-data {
	    0% {
	        margin-top: 1000px;
	        opacity: 0;
	    }
	    100% {
	        margin-top: 0;
	        opacity: 1;
	    }
	}
	@-webkit-keyframes logobig-data{
		0% {
		    -webkit-transform: scale(.3);
		    opacity: 0;
		}
		50% {
		    -webkit-transform: scale(1.2);
		    opacity: .5;
		}
		100% {
		    -webkit-transform: scale(1);
		    opacity: 1;
		}
	}
	@keyframes logobig-data{
		0% {
		    -webkit-transform: scale(.3);
		    opacity: 0;
		}
		50% {
		    -webkit-transform: scale(1.2);
		    opacity: .5;
		}
		100% {
		    -webkit-transform: scale(1);
		    opacity: 1;
		}
	}
	.register{
		line-height: 5%;
		text-align: center;
		margin-top: 30px;
		font-size: 12px;
	}
	
	.basic_wrap {
		max-width: 750px;
		background: url(../images/shop2/1.png) repeat top;
		height: 100vh;
		padding-bottom: 10%;
		background-color: #FFF;
		filter: opacity(80%);
		background-position: 50%;
		background-size: cover;
		display: inline-block;
		width: 100%;
		min-height: 100vh;
	}
	.area_code{
		font-size: 16px;
		line-height: 20px;
		padding: 5px;
	}
	
	
	
	
	
	
	
	
	
	
	.cont{
	position: absolute;
	width: 100%;
	height: 100vh;
	background-size: 100% 100%;
	bottom: 0;
	background: linear-gradient(-45deg,#7e5678,#e6c3a1);
	z-index: 2
	}
	
	.bg-img{
	width: 100%;
	height: 100%;
	-o-object-fit: cover;
	object-fit: cover
	}
	
	.bg-wrapper{
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: linear-gradient(hsla(0,0%,100%,0),#7e5678)
	}
	
	.imgList{
	position: absolute;
	right: 17px;
	z-index: 999;
	top: 20px;
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100px;
	justify-content: space-around
	}
	
	.imgList img{
	width: 40px;
	height: 40px
	}
	
	.inputs{
	top: 0;
	position: absolute;
	margin-top: 17vh;
	border-radius: 50px;
	opacity: .85;
	padding: 0 30px;
	box-sizing: border-box;
	width: 100%
	}
	
	.names{
		font-size: 14px;
		color: #fff;
		font-weight: 700;
	    line-height: 30px;
	}
	
	input{
		background: #fff;
		border: none;
		width: 100%;
		border-radius: 6.667vw;
		padding: 7px 0;
		font-size: 16px;
		border: 0;
		height: 60px;
		text-align: center
	}
	
	.registerBtn{
		margin: 3vh auto 0 auto;
		line-height: 60px;
		text-align: center;
		margin-top: 11.333vw;
		width: 100%;
		height: 60px;
		border-radius: 6.667vw;
		color: #fff;
		background: linear-gradient(90deg,#ff7791,#ff5d7a);
		font-size: 16px;
		font-weight: bolder
	}
	.form-group {
	    margin-bottom: 15px;
	}

	.basic_wrap {
		position: relative;
		display: block;
		width: 100%;
		max-width: 750px;
		min-height: 100vh;
		height: 100vh;
		padding-bottom: 0;
		overflow: hidden;
		background: #fff;
		color: #16223a;
		filter: none;
		box-sizing: border-box;
	}

	.login_bg {
		position: relative;
		z-index: 10;
		width: 100%;
		height: 50px;
		background: #fff;
		border-bottom: 1px solid rgba(240, 242, 245, 1);
		box-sizing: border-box;

		.back_left {
			opacity: 0.88;
		}

		.big_tit {
			max-width: 68%;
			color: #16223a;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			word-break: normal;
		}

		.language {
			top: 9px;
			right: 14px;
			width: 32px;
			height: 32px;
			display: flex;
			align-items: center;
			justify-content: center;
			overflow: hidden;
			border-radius: 50%;
			border: 1px solid rgba(255, 93, 122, 0.34);
			background: rgba(255, 93, 122, 0.12);
		}

		.language img {
			width: 24px;
			height: 24px;
			object-fit: cover;
			border-radius: 50%;
		}
	}

	.cont {
		position: absolute;
		inset: 50px 0 0;
		width: 100%;
		height: auto;
		background: #fff;
		z-index: 1;
		overflow-y: auto;
	}

	.bg-img {
		position: absolute;
		inset: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		opacity: 1;
		filter: none;
	}

	.bg-wrapper {
		position: relative;
		inset: auto;
		z-index: 1;
		min-height: calc(100vh - 50px);
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: flex-start;
		padding: 34px 16px 24px;
		background: linear-gradient(180deg, rgba(25, 24, 24, 0.18) 0%, rgba(25, 24, 24, 0.58) 58%, rgba(25, 24, 24, 0.84) 100%);
		box-sizing: border-box;
	}

	.logos {
		position: relative;
		width: 100%;
		margin: 30px 0 ;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.login-logo-img {
		width: auto;
		max-width: 150px;
		// max-height: 72px;
		object-fit: contain;
	}

	.inputs {
		position: relative;
		top: auto;
		width: 100%;
		max-width: 430px;
		margin-top: 0;
		padding: 18px;
		border-radius: 14px;
		border: 1px solid rgba(255, 93, 122, 0.28);
		background: rgba(28, 25, 28, 0.64);
		box-shadow: 0 18px 40px rgba(0, 0, 0, 0.18);
		-webkit-backdrop-filter: blur(8px) saturate(120%);
		backdrop-filter: blur(8px) saturate(120%);
		opacity: 1;
		box-sizing: border-box;
	}

	.form-signin {
		width: 100%;
	}

	.form-group {
		margin-bottom: 12px;
	}

	.names {
		margin-bottom: 6px;
		color: rgba(248, 250, 252, 0.72);
		font-size: 12px;
		font-weight: 600;
		line-height: 18px;
	}

	.names span {
		margin-right: 3px;
		color: #ff5e64;
	}

	input {
		width: 100%;
		height: 44px;
		padding: 0 14px;
		border-radius: 12px;
		border: 1px solid rgba(255, 93, 122, 0.18);
		background: rgba(27, 27, 30, 0.76);
		color: #f8fafc;
		caret-color: #ff7791;
		font-size: 14px;
		text-align: left;
		box-sizing: border-box;
		outline: none;
		transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
	}

	input::placeholder {
		color: rgba(248, 250, 252, 0.52);
		font-size: 14px;
	}

	input:focus {
		border-color: rgba(255, 119, 145, 0.72);
		background: rgba(25, 24, 27, 0.86);
		box-shadow: 0 0 0 3px rgba(255, 93, 122, 0.14);
	}

	input::selection {
		background: rgba(255, 93, 122, 0.42);
		color: #fff;
	}

	input:-webkit-autofill,
	input:-webkit-autofill:hover,
	input:-webkit-autofill:focus {
		-webkit-text-fill-color: #f8fafc;
		box-shadow: 0 0 0 1000px rgba(27, 27, 30, 0.92) inset;
		transition: background-color 9999s ease-out;
		caret-color: #ff7791;
	}

	.registerBtn {
		width: 100%;
		height: 44px;
		line-height: 44px;
		margin: 16px auto 0;
		border-radius: 12px;
		border: 1px solid rgba(255, 93, 122, 0.42);
		background: linear-gradient(180deg, #ff7791 0%, #ff5574 100%);
		color: #fff;
		font-size: 14px;
		font-weight: 700;
		box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.18);
	}

	.row.mx-0.text-center.justify-content-center {
		margin-top: 35px;
		font-size: 14px;
		text-align: center;
	}

	.auth-link {
		color: #ff5d7a;
		font-size: 14px;
		font-weight: 700;
	}

	.basic_wrap .form {
		display: none;
	}

	/deep/ .van-dialog {
		background: #fff;
		color: #16223a;
	}

	@media screen and (max-height: 680px) {
		.bg-wrapper {
			padding-top: 16px;
		}

		.logos {
			margin-bottom: 10px;
		}

		.login-logo-img {
			max-height: 54px;
		}

		.inputs {
			padding: 14px;
		}

		.form-group {
			margin-bottom: 9px;
		}
	}
</style>
